// React
import React, { useState } from "react";

// Components
import InviteTeamMemberModal from "../components/InviteTeamMemberModal";
import UserSideBar from "../components/UserSideBar";
import UserContainer from "../components/UserContainer";

// EventifyAPI
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";

export default function TeamPage(appProps) {
  const [user, setUser] = useState(null);
  const [isInviteTeamMemberModalOpen, setIsInviteTeamMemberModalOpen] = useState(false);

  // TODO: once userids are uuid instead of email, have this be route instead
  // /user/:userid
  const viewUserAction = (userid) => {
    ModelCache.getUserById(
      userid,
      result => {
        setUser(result);
      }
    );
  };

  return (
    <div className="team-page">
      <UserSideBar
        email={appProps.email}
        organizationid={appProps.organizationid}
        viewUserAction={viewUserAction}
        showInviteTeamMemberModal={() => {setIsInviteTeamMemberModalOpen(true);}}
      />

      <UserContainer
        user={user}
      />

      <InviteTeamMemberModal
        visible={isInviteTeamMemberModalOpen}
        organizationid={appProps.organizationid}
        onCancel={() => {setIsInviteTeamMemberModalOpen(false);}}
      />

    </div>
  );
}
